import { useTheme } from '@mui/material';
import { colors } from '@watter/shared-components';

const NotificationAlert = () => {
    const theme = useTheme();
    const color = theme.palette.mode === 'dark' ? colors.white : colors.blackColor;
    return (
        <svg width="74" height="82" viewBox="0 0 74 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.6666 63.2222V67.6667C23.6666 71.2029 25.0713 74.5943 27.5718 77.0948C30.0723 79.5952 33.4637 81 36.9999 81C40.5361 81 43.9275 79.5952 46.428 77.0948C48.9285 74.5943 50.3332 71.2029 50.3332 67.6667V63.2222M28.111 9.88889C28.111 7.53141 29.0475 5.27049 30.7145 3.60349C32.3815 1.9365 34.6424 1 36.9999 1C39.3574 1 41.6183 1.9365 43.2853 3.60349C44.9523 5.27049 45.8888 7.53141 45.8888 9.88889C50.9928 12.3023 55.3439 16.0592 58.4757 20.7569C61.6074 25.4545 63.4018 30.9159 63.6666 36.5556V49.8889C64.001 52.652 64.9796 55.298 66.5235 57.6139C68.0674 59.9297 70.1335 61.8507 72.5554 63.2222H1.44434C3.86629 61.8507 5.93238 59.9297 7.47628 57.6139C9.02018 55.298 9.99876 52.652 10.3332 49.8889V36.5556C10.5979 30.9159 12.3923 25.4545 15.5241 20.7569C18.6559 16.0592 23.007 12.3023 28.111 9.88889Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default NotificationAlert;
